import React from 'react'
import { Link, l } from '@manychat/manyui'

import { typedRouting } from 'utils/router'

import cm from './common.module.css'

export const SmbAppDisconnected = () => {
  const navigate = typedRouting.useNavigate()
  return (
    <span>
      {l.translate(
        'Your WhatsApp account was disconnected from Manychat due to a Meta issue. Your contacts and chats are safe. Restore the connection ',
      )}
      <Link className={cm.link} onClick={() => navigate.settings({ hash: 'whatsApp' })}>
        {l.translate('in settings')}
      </Link>
    </span>
  )
}
